import {PasswordChange} from "@/components/account/config";
import {axiosBase} from "@/api/axios-base";
import {URLS} from "@/api/config";

export const postPasswords = async (data: PasswordChange): Promise<null> => {
    return await axiosBase.post(URLS.passwordChange(), data)
}
